<div class="page-layout simple left-sidebar inner-sidebar inner-scroll">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <button
            mat-icon-button
            class="sidebar-toggle mr-8"
            fxHide.gt-md
            (click)="toggleSidebar('left-sidebar')"
        >
            <mat-icon>menu</mat-icon>
        </button>

        <div>
            <h2>{{ "QUOTE.QUOTE" | translate | uppercase }}</h2>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">
        <!-- SIDEBAR -->
        <fuse-sidebar
            class="sidebar"
            name="left-sidebar"
            position="left"
            lockedOpen="gt-md"
        >
            <!-- SIDEBAR CONTENT -->
            <div class="content p-24" fusePerfectScrollbar>
                <div
                    *ngIf="cargandoCategorias"
                    fxLayout="row"
                    fxLayoutAlign="space-around center"
                >
                    <mat-spinner color="accent" diameter="50"></mat-spinner>
                </div>
                <app-categorias
                    *ngIf="categorias"
                    [categorias]="categorias"
                    (buscarServicios)="buscarServiciosPorCategoria($event)"
                ></app-categorias>
            </div>
            <!-- / SIDEBAR CONTENT -->
        </fuse-sidebar>
        <!-- / SIDEBAR -->

        <!-- CENTER -->
        <div class="center p-24" fusePerfectScrollbar>
            <!-- CONTENT -->
            <div class="content p-24">
                <div
                    fxFlex
                    fxLayoutAlign="start start"
                    fxLayout.lt-md="column"
                    fxLayoutGap="30px"
                >
                    <!-- <fuse-demo-content></fuse-demo-content>-->
                    <div fxFlex="65" fxFlexFill fxFlex.lt-md="100">
                        <app-tabla-servicios
                            *ngIf="sucursales"
                            [sucursales]="sucursales"
                            (agregarServicio)="
                                openDialogAgregarServicio($event, false, null)
                            "
                        ></app-tabla-servicios>
                    </div>

                    <div fxFlex="35" fxFlex.lt-md="100" fxFlexFill>
                        <!--<fuse-demo-sidebar></fuse-demo-sidebar>-->
                        <app-servicios-seleccionados
                            [serviciosSeleccionados]="serviciosSeleccionados"
                            [total]="total"
                            (quitarServicio)="quitarServicio($event)"
                            (editarServicio)="editarServicio($event)"
                        ></app-servicios-seleccionados>
                        <mat-divider></mat-divider>
                        <app-servicios-complementarios
                            *ngIf="sucursales"
                            [serviciosComplementarios]="
                                serviciosComplementarios
                            "
                            (quitarServicio)="
                                quitarServicioComplementario($event)
                            "
                            (editarServicio)="
                                editarServicioComplementario($event)
                            "
                            (agregarServicio)="
                                openDialogAgregarServicioComplementario($event)
                            "
                        ></app-servicios-complementarios>
                    </div>
                </div>
            </div>
            <!-- / CONTENT -->
        </div>
        <!-- / CENTER -->
    </div>

    <div fxLayout="row" fxLayoutAlign="space-around center" class="m-24">
        <div>
            <button
                mat-raised-button
                color="primary"
                (click)="solicitarCotizacion()"
                [disabled]="
                    (serviciosSeleccionados.length === 0 &&
                    serviciosComplementarios.servicios.length === 0) || procesando
                "
            >
                Solicitar Cotización
            </button>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
